class e {
  smscode() {
    return "999999";
  }
}
export {
  e as default
};
